import React, { FC } from 'react';
import Button from '../../components/Button';
import useRefreshPage from '../../hooks/useRefreshPage';
import styles from './styles/index.module.scss'

const Error500: FC = () => {
    const { refreshPage } = useRefreshPage();
    return (
        <div className={styles['wrap']}>
            <div className={styles['info-block']}>
                <h1 className={styles['info-block--title']}>Ошибка обращения к серверу</h1>
                <p className={styles['info-block--desc']}>
                    Мы уже устраняем неисправность, попрорбуйте обновить страницу через некоторое время.
                    Приносим извинения за временные неудобства!
                </p>
                <div className={styles['actions']}>
                    <Button
                        href='/'
                        className={styles['actions--btn']}
                    >
                        Вернуться на главную
                    </Button>
                    <Button
                        onClick={refreshPage}
                        className={styles['actions--btn']}
                        theme='btn--gray'
                    >
                        Обновить страницу
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Error500;